import images from './images';

export const brands = [
  {
    id: 0,
    image: images.sDLogo,
  },
];
